import { ca } from '@cian/analytics';
import { TDeviceType } from '@cian/ui-kit';
import { debounce } from 'throttle-debounce';

import { IJsonQuery } from '../../../packages/api-models/common/json_query';

interface IProps {
  jsonQuery: IJsonQuery;
  timeInMilliseconds: number;
  startTimestamp: number;
  success: boolean;
  deviceType: TDeviceType | undefined;
  queryString: string;
}

function trackPinLoadSuccess({
  jsonQuery,
  deviceType,
  timeInMilliseconds,
  startTimestamp,
  success,
  queryString,
}: IProps) {
  ca('eventSite', {
    event: 'oldevent',
    name: 'oldevent',
    category: 'Map',
    action: 'success_time_sopr',
    label: String(timeInMilliseconds),
    page: {
      pageType: 'Map',
      siteType: deviceType === 'desktop' ? 'desktop' : 'mobile',
      queryString,
      extra: {
        requestStartTimestamp: String(startTimestamp),
        requestSuccess: success,
      },
    },
    sc: jsonQuery,
  });
}

export const trackPinLoadSuccessDebounced = debounce(1000, trackPinLoadSuccess);
